import React from 'react'
import { Head } from '@inertiajs/react'
import { PublicLayout } from '@/components/frontend/templates/PublicLayout'
import { ContactSection } from '@/components/frontend/organisms/ContactSection'
import { FAQSection } from '@/components/frontend/organisms/FAQSection'
import { useContactVM } from './Contact.vm'
import { useTranslation } from '@/hooks/useTranslation'
import type { PageProps } from '@/types'

type Props = PageProps<{
  errors: Record<string, string>
  success: boolean
}>

const Contact: React.FC<Props> = ({ flash }) => {
  const contactForm = useContactVM(flash)
  const { t } = useTranslation()

  return (
    <PublicLayout>
      <Head title={t('head.contact_title')} />
      <ContactSection form={contactForm} headingLevel="h1" />
      <FAQSection />
    </PublicLayout>
  )
}

export default Contact
